// extracted by mini-css-extract-plugin
export default {"local-participant-container":"LocalParticipantLayout_local-participant-container__M4ntx","hide":"LocalParticipantLayout_hide__t4OIO"};